import React from 'react'
import { getAuth, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { useState } from 'react'
import {Link,useNavigate} from 'react-router-dom'
import {doc,setDoc,serverTimestamp} from 'firebase/firestore';
import { ReactComponent as ArrowRightIcon } from '../assets/svg/keyboardArrowRightIcon.svg'
import visibilityIcon from '../assets/svg/visibilityIcon.svg'
import {app,db} from '../firebase.config' 
import { toast } from 'react-toastify'
import OAuth from '../components/OAuth';


function SignUp() {
  const [showPassword,setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name:"",
    email:"",
    password:""
  })
  const {name,email,password} = formData;
  const navigate =useNavigate();
  const onChange = (e)=>{
    setFormData((prevState)=>({
      ...prevState,
      [e.target.id] :  e.target.value
    }))
  } 

  const onSubmit = async (e) =>{
    e.preventDefault()

    try{
      const auth = getAuth(app);
      const userCredential = await createUserWithEmailAndPassword(auth,email,password);
      const user = userCredential.user;
      
      //same as
      // createUserWithEmailAndPassword(auth, email, password)
      //   .then((userCredential) => {
      //     const user = userCredential.user;
      //   }) 

      updateProfile(auth.currentUser,{
        displayName: name
      })

      const formDataCopy = {...formData}
      delete formDataCopy.password;
      formDataCopy.timestamp = serverTimestamp()
      setDoc(doc(db,'users',user.uid),formDataCopy);

      navigate('/');

    }catch(error){
      console.log(error);
      toast.error("something went wrong with the Registration")
    }

  }


  return (
    <>
      <div className='pageContainer'>
        <header>
          <p className='pageHeader'>Welcome Back!</p>
        </header>

        <form onSubmit={onSubmit}>
        <input
            type='text'
            className='nameInput'
            placeholder='Name'
            id='name'
            value={name}
            onChange={onChange}
          />

          <input
            type='email'
            className='emailInput'
            placeholder='Email'
            id='email'
            value={email}
            onChange={onChange}
          />

          <div className='passwordInputDiv'>
            <input
              type={showPassword ? 'text' : 'password'}
              className='passwordInput'
              placeholder='Password'
              id='password'
              value={password}
              onChange={onChange}
            />

            <img
              src={visibilityIcon}
              alt='show password'
              className='showPassword'
              onClick={() => setShowPassword((prevState) => !prevState)}
            />
          </div>

          <Link to='/forgot-password' className='forgotPasswordLink'>
            Forgot Password
          </Link>

          <div className='signInBar'>
            <p className='signInText'>Sign Up</p>
            <button type="submit" className='signInButton'>
              <ArrowRightIcon fill='#ffffff' width='34px' height='34px' />
            </button>
          </div>
        </form>

        <OAuth />

        <Link to='/sign-in' className='registerLink'>
          Sign In Instead
        </Link>
      </div>
    </>
  )
}

export default SignUp